// ADDED: API client for website onboarding wizard
// PRD Reference: Dashboard Redesign + Website Onboarding Wizard plan
import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

// Helper to build URL with website_id query param
function withWebsiteId(url, websiteId) {
  if (!websiteId) return url
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}website_id=${websiteId}`
}

// Website endpoints
export function getWebsite(websiteId) {
  return axios.get(withWebsiteId('/ajax/onboarding/website', websiteId))
}

export function updateWebsite(data, websiteId) {
  return axios.put(withWebsiteId('/ajax/onboarding/website', websiteId), { website: data })
}

export function getWizardProgress(websiteId) {
  return axios.get(withWebsiteId('/ajax/onboarding/website/progress', websiteId))
}

export function completeStep(stepNumber, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/website/complete_step', websiteId), { step: stepNumber })
}

export function uploadLogo(formData, opts = {}, websiteId = null) {
  return axios.post(withWebsiteId('/ajax/onboarding/website/upload_logo', websiteId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...opts
  })
}

export function removeLogo(websiteId) {
  return axios.delete(withWebsiteId('/ajax/onboarding/website/remove_logo', websiteId))
}

// Services endpoints
export function getServices(websiteId) {
  return axios.get(withWebsiteId('/ajax/onboarding/services', websiteId))
}

export function createService(data, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/services', websiteId), { service: data })
}

export function updateService(id, data, websiteId) {
  return axios.put(withWebsiteId(`/ajax/onboarding/services/${id}`, websiteId), { service: data })
}

export function deleteService(id, websiteId) {
  return axios.delete(withWebsiteId(`/ajax/onboarding/services/${id}`, websiteId))
}

export function reorderServices(serviceIds, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/services/reorder', websiteId), { service_ids: serviceIds })
}

export function uploadServicePhotos(serviceId, formData, opts = {}, websiteId = null) {
  return axios.post(withWebsiteId(`/ajax/onboarding/services/${serviceId}/upload_photos`, websiteId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...opts
  })
}

export function removeServicePhoto(serviceId, photoId, websiteId) {
  return axios.delete(withWebsiteId(`/ajax/onboarding/services/${serviceId}/remove_photo/${photoId}`, websiteId))
}

// Service Areas endpoints
export function getServiceAreas(websiteId) {
  return axios.get(withWebsiteId('/ajax/onboarding/service_areas', websiteId))
}

export function createServiceArea(data, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/service_areas', websiteId), { service_area: data })
}

export function deleteServiceArea(id, websiteId) {
  return axios.delete(withWebsiteId(`/ajax/onboarding/service_areas/${id}`, websiteId))
}

// Gallery Images endpoints
export function getGalleryImages(websiteId) {
  return axios.get(withWebsiteId('/ajax/onboarding/gallery_images', websiteId))
}

export function createGalleryImage(data, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/gallery_images', websiteId), { gallery_image: data })
}

export function updateGalleryImage(id, data, websiteId) {
  return axios.put(withWebsiteId(`/ajax/onboarding/gallery_images/${id}`, websiteId), { gallery_image: data })
}

export function deleteGalleryImage(id, websiteId) {
  return axios.delete(withWebsiteId(`/ajax/onboarding/gallery_images/${id}`, websiteId))
}

export function reorderGalleryImages(imageIds, websiteId) {
  return axios.post(withWebsiteId('/ajax/onboarding/gallery_images/reorder', websiteId), { image_ids: imageIds })
}

export function uploadGalleryBatch(formData, opts = {}, websiteId = null) {
  return axios.post(withWebsiteId('/ajax/onboarding/gallery_images/upload_batch', websiteId), formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    ...opts
  })
}

// URL Import endpoints
export function createImport(websiteId, url) {
  return axios.post(withWebsiteId('/ajax/onboarding/imports', websiteId), {
    import: { url }
  })
}

export function getImport(websiteId, importId) {
  return axios.get(withWebsiteId(`/ajax/onboarding/imports/${importId}`, websiteId))
}

export function applyImport(websiteId, importId, editedData = null) {
  return axios.post(withWebsiteId(`/ajax/onboarding/imports/${importId}/apply`, websiteId), {
    edited_data: editedData
  })
}
